module.exports = __webpack_public_path__ + "img/empty.af08cff7.png";